import { Route } from '@angular/router';
import { AppUrls } from '../../../../../common/dto/app-urls';
import { ChecklistsRoute } from './checklists/checklists.route';
import { ElementsRoute } from './elements/elements.routes';
import { HintsRoute } from './hints/hints.routes';

export const GuideRoute: Route = {
  path: AppUrls.Dashboard._.Guide.relativeUrl,
  children: [
    HintsRoute,
    ElementsRoute,
    ChecklistsRoute,
    {
      path: '**',
      redirectTo: HintsRoute.path,
    },
  ],
};
